const importHistory = {
  tableTitle: "Import History",
  tableDescription: "List of previously imported documents.",
  tableColumnsDetails: {
    column1: "Type",

    column2: "Document Name",

    column3: "Entity Type",

    column4: "Total Records",

    column5: "Falied",

    column6: "Status",

    column7: "Created By",

    column8: "Created On",
  },
  statusLabels: {
    success: "Success",
    failed: "Failed",
    inProgress: "In Progress",
    queued: "Queued",
  },
  importRecords: {
    bannerDetails: {
      title: "Type",
      label1: "Document File Name",
      label2: "Status",
      label3: "Entity Type",
      label4: "Created On",
      label5:"Created By"
    },
    columnDetails: {
      column1: "Row Number",

      column2: "Status",

      column3: "Error Message",
    },
    failed: "Failed",
    success: "Success",
    tableTitle: "Import Records",
    tableDescription: "List of previously imported records.",
    resetFilter: "Reset Filter",
    statusFilter: "Status Filter",
    successfulRecords: "Successful Records",
    failedRecords: "Failed Records",
  },
};

export default importHistory;
